import { isElementNode } from 'anodum';

const unwrapElement = (element) => {
  if (!isElementNode(element)) {
    console.error(`${element} is not an element`);
    return null;
  }

  if (!element.parentNode) {
    console.error(`${element} has no parent node`);
    return null;
  }

  const childNodes = Array.from(element.childNodes);
  const fragment = document.createDocumentFragment();
  fragment.append(...childNodes);
  element.parentNode.replaceChild(fragment, element);
  return childNodes;
};

export default unwrapElement;
